import client from "../client";
import { apiList } from "../apiList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // returns list bettingOldHistoryof all the people
  bettingOldHistory: (payload, signal) => client.post(apiList.bettingOldHistory, {json: payload, signal}),
};

// {userId: userId, startDate: startDate, endDate: endDate}